export default "__VITE_ASSET__DeZ8yzrQ__"